import React, { useEffect, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import * as THREE from 'three';

function InteractiveTouchDesigner() {
  const wsRef = useRef(null);
  const videoRef = useRef(null);
  const meshRef = useRef(null);

  // Establish WebSocket connection with TouchDesigner
  useEffect(() => {
    wsRef.current = new WebSocket('ws://localhost:8080'); // Change URL/port as needed
    wsRef.current.onopen = () => {
      console.log('WebSocket connection established with TouchDesigner');
    };
    wsRef.current.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, []);

  // Send mouse move events to TouchDesigner via WebSocket
  const handleMouseMove = (event) => {
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      const normalizedX = event.clientX / window.innerWidth;
      const normalizedY = event.clientY / window.innerHeight;
      const message = JSON.stringify({
        type: 'mouseMove',
        x: normalizedX,
        y: normalizedY,
      });
      wsRef.current.send(message);
    }
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Set up video texture from the hidden video element
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    // Try to play the video; if it fails, log the error.
    video.play().catch((err) => console.error('Video play error:', err));

    const videoTexture = new THREE.VideoTexture(video);
    videoTexture.minFilter = THREE.LinearFilter;
    videoTexture.magFilter = THREE.LinearFilter;
    videoTexture.format = THREE.RGBFormat;

    if (meshRef.current) {
      meshRef.current.material.map = videoTexture;
      meshRef.current.material.needsUpdate = true;
    }
  }, []);

  return (
    <>
      {/* Hidden video element – use opacity/size to hide it while keeping it in the DOM */}
      <video
        ref={videoRef}
        src="https://www.w3schools.com/html/mov_bbb.mp4"  // Replace with your actual stream URL
        loop
        muted
        playsInline
        autoPlay
        crossOrigin="anonymous"
        style={{ width: '0px', height: '0px', opacity: 0 }}
      />
      <Canvas camera={{ position: [0, 5, 15], fov: 50 }}>
        <ambientLight intensity={0.5} />
        <pointLight position={[10, 10, 10]} />
        {/* Mesh displaying the TouchDesigner video texture */}
        <mesh ref={meshRef} position={[0, 5, -10]}>
          <planeGeometry args={[16, 9]} />
          <meshBasicMaterial />
        </mesh>
        <OrbitControls enableZoom={false} enablePan={false} />
      </Canvas>
    </>
  );
}

export default InteractiveTouchDesigner;
